export const iconFontAwesomeSecurityDoorOpen = (
	<i className="fa-solid fa-door-open"></i>
);
